module.exports = __webpack_public_path__ + "img/zachary-taylor.1cf62c38.png";